module.exports = new Promise((resolve, reject) => {
      const urlParams = new URLSearchParams(window.location.search);
      const resolvedHost = urlParams.get('panelPartyCorrection') ?? 'https://panel-party-correction.thoughtriver.com';
      console.log('panelPartyCorrection', 'Resolved host:', resolvedHost);
      const resolvedUrl = `${resolvedHost}/remoteEntry.js`;

      const script = document.createElement('script');
      script.src = resolvedUrl;
      script.onload = () => {
        const proxy = {
          get: (request) => window['panelPartyCorrection'].get(request),
          init: (...args) => {
            try {
              return window['panelPartyCorrection'].init(...args);
            } catch (e) {
              console.log('Remote container already initialized');
            }
          },
        }
        resolve(proxy);
      }

      document.head.appendChild(script);
    });